/**
 * evidence.api.ts — visor de fotos de evidencia (Mini App en MediaBucket).
 * Espejo de `aws-serverless/src/api/evidence-photos.handler.ts`. Solo admins.
 */

import { apiClient } from './client';

export interface EvidenceFolder {
  prefix: string;
  label: string;
  kind: 'lote' | 'pending';
}

export interface EvidencePhoto {
  key: string;
  size: number;
  lastModified: string;
}

export const fetchEvidenceFolders = async (): Promise<EvidenceFolder[]> =>
  (await apiClient.get('/api/evidence/folders')).data.folders ?? [];

export const fetchEvidencePhotos = async (prefix: string): Promise<EvidencePhoto[]> =>
  (await apiClient.get('/api/evidence/photos', { params: { prefix } })).data.photos ?? [];

export const fetchEvidencePhotoUrl = async (key: string, download: boolean): Promise<string> =>
  (await apiClient.get('/api/evidence/photo-url', { params: { key, ...(download ? { download: '1' } : {}) } })).data.url;
